import React, { useState } from 'react';
import { LinearProgress, Tooltip } from '@material-ui/core';
import AlertDialog from '../../UI/AlertDialog';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from 'react-i18next';
import API from '../../../api-graphql';
import PropTypes from 'prop-types';

import { CONSTANTS } from '../../../constants/constants';

const DeleteAttachment = (props) => {
  const { input, index, getData } = props;
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(t('deleteAttachment:deleteConfirmationMessage'));

  async function handleDelete (acept) {
    setLoading(true);
    try {
      if (acept) {
        input.annexes.splice(index, 1);
        input.updatedAt = new Date().toISOString();
        await API.updateDocument(input);
        getData();
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setError(t('deleteAttachment:genericError'));
      setOpen(true);
    }
  }

  if (loading) {
    return (
      <div style={{ padding: 0, position: 'absolute', top: '100%', left: 0, width: '100%', zIndex: 9999, textAlign: 'center' }}>
        <LinearProgress />
      </div>
    );
  }

  if (input.status !== CONSTANTS.DOCUMENT.STATUS.INIT) return null;

  return (
    <>
      <AlertDialog open={open} title='Message' description={error} callbackFunc={handleDelete} setOpen={setOpen} />
      <Tooltip disableFocusListener title={t('documentMenu:delete')}>
        <IconButton onClick={() => setOpen(true)}style={{ color: 'black' }}>
          <DeleteForeverIcon style={{ fontSize: '18px' }} />
        </IconButton>
      </Tooltip>
  </>
  );
};

DeleteAttachment.propTypes = {
  input: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  getData: PropTypes.func.isRequired
};

export default DeleteAttachment;
